export const MODULE_NAME = 'manageConfig';
